import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "spectrum_admin_token";
const COLLAB_TOKEN_KEY = "spectrum_collab_token";

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);
export const setAdminToken = (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);

export const getCollabToken = () => localStorage.getItem(COLLAB_TOKEN_KEY);
export const setCollabToken = (t) => localStorage.setItem(COLLAB_TOKEN_KEY, t);
export const clearCollabToken = () => localStorage.removeItem(COLLAB_TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  if (!config.headers.Authorization) {
    const admin = getAdminToken();
    const collab = getCollabToken();
    if (admin) config.headers.Authorization = `Bearer ${admin}`;
    else if (collab) config.headers.Authorization = `Bearer ${collab}`;
  }
  return config;
});

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);
